export const styles = {
  container: {
    paddingTop: '2em',
  },
  tableContainer: {
    marginTop: '1em',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  tableHeader: {
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#2a2f49',
    textAlign: 'center',
  },
  tableIcon: {
    textAlign: 'center',
  },
};
